import { createStyles, makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles(
	theme =>
		createStyles({
			root: {
				background: theme.palette.grey["A400"],
				overflow: "scroll"
			},
			history: {
				padding: "10px 16px 6px 16px",
				position: "relative"
			},
			historyItem: {
				background: theme.palette.common.white,
				position: "relative",
				borderRadius: 6
			},
			header: {
				display: "flex",
				justifyContent: "space-between",
				paddingBottom: 12,
				borderBottom: `1px dashed ${theme.palette.grey[800]}`
			},
			times: {
				display: "flex",
				alignItems: "center",
				color: theme.palette.primary.contrastText,
				"& > img": {
					marginRight: 5
				}
			},
			time: {
				padding: "0px 20px"
			},
			bodyTime: {
				paddingBottom: 20,
				borderBottom: `1px dashed ${theme.palette.grey[800]}`
			},
			status: {
				color: theme.palette.common.white,
				padding: "5px 10px",
				fontSize: 12,
				borderRadius: 4,
				fontWeight: 500,
				backgroundColor: "red"
			},
			rootBody: {
				padding: "0px 16px"
			},
			rootProduct: {
				display: "flex",
				alignItems: "center"
			},
			rootImage: {
				padding: 10
			},
			rootInfo: {
				width: "100%"
			},
			name: {
				color: theme.palette.primary.contrastText,
				fontWeight: 500,
				fontSize: 14,
				overflow: "hidden",
				display: "inline-block",
				textOverflow: "ellipsis",
				whiteSpace: "nowrap",
				width: 235
			},
			quantity: {
				color: theme.palette.primary.contrastText,
				fontWeight: 500,
				fontSize: 14
			},
			subText: {
				color: theme.palette.grey[50],
				fontSize: 14
			},
			body: {
				display: "flex",
				marginTop: 10,
				alignItems: "center",
				justifyContent: "space-between"
			},
			btnWatchProduct: {
				width: "100%",
				textAlign: "center",
				"& > button": {
					fontWeight: 400,
					color: theme.palette.secondary.main,
					textTransform: "none",
					padding: 0
				}
			},
			totalPrice: {
				marginTop: 10,
				background: theme.palette.grey[600],
				borderRadius: 4
			},
			textPrice: {
				color: theme.palette.primary.contrastText,
				fontWeight: 500,
				fontSize: 16,
				textAlign: "end"
			},
			btnProductDetail: {
				width: "100%",
				marginTop: 20,
				paddingBottom: 10,
				textAlign: "center",
				"& > button": {
					fontWeight: 400,
					color: theme.palette.secondary.main,
					textTransform: "none",
					padding: "3px 20px",
					border: `1px solid ${theme.palette.secondary.main}`
				}
			}
		}),
	{
		name: "MerchangdisingHistoryOrder",
		index: 1
	}
);

export default useStyles;
